module.exports = __webpack_public_path__ + "static/media/search.aba988f9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/search.mp4
// module id = 1970
// module chunks = 0